<template>
  <div class="router-tags">
    <!--    tag.fullPath-->
    <a-tabs
      type="editable-card"
      v-model="editableTabsValue"
      hideAdd
      @edit="onEdit"
      @tabClick="handleGoRoute"
    >
      <a-tab-pane
        v-for="(tag, index) in editableTabs"
        aria-disabled="true"
        @contextmenu.prevent.native="openMenu($event)"
        :key="tag.idNum"
        :tab="tag.title"
        :closable="tag.path != '/HomeWorks'"
        >{{ tag.title }}</a-tab-pane
      >
    </a-tabs>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState, mapActions } from "vuex";
import { findIndex } from "lodash";
import { getRecrdData, setRecrdData } from "@/plugins/oauth";

import { TeacherSubject } from "@/config/typeConfig";
import { DELETE_ROUTE_TAGS } from "../store/types";

export default {
  name: "routerTags",
  data() {
    return {
      TeacherSubject,
      tagsBox: null,
      offset: 200,
      editableTabsValue: "1",
      leftValue: 0,
      viewWidth: 0, //可见宽度
      realWidth: 0, //实际宽度
      leftDisabled: true,
      rightDisabled: true,
      editableTabs: []
    };
  },
  computed: {
    ...mapGetters({
      keepLiveTags: "getKeepLiveTags"
    }),
    ...mapState(["activeKey"])
  },
  created() {
    this.initRecrd();
  },
  watch: {
    $route: function(route) {
      //监听路由的变化，动态生成editableTabs
      let flag = true; //判断是否需要新增页面
      let recrdData = JSON.parse(getRecrdData() || []);

      const excludeTags = ["/dashboard", "/login", "/"];

      const { fullPath, path, meta, query, name } = route;

      // recrdData.forEach((item) => {
      //   if (i.fullPath === route.fullPath) {
      //     flag = false;
      //     this.editableTabsValue = item.idNum;
      //   }
      // });

      if (!excludeTags.includes(fullPath)) {
        recrdData.forEach(item => {
          if (item.fullPath === route.fullPath) {
            flag = false;
            this.editableTabsValue = item.idNum;
          }
        });
        if (flag) {
          let idNum = Number(this.editableTabs.slice(-1)[0].idNum);
          this.editableTabsValue = JSON.stringify(idNum + 1);
          if (meta.title !== "登录") {
            let SubjectTitle = "";
            if (
              path == "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType"
            ) {
              SubjectTitle = this.TeacherSubject[query.type];
            }
            this.editableTabs.push({
              title: SubjectTitle ? SubjectTitle : meta.title,
              idNum: this.editableTabsValue,
              name,
              fullPath,
              path
            });
          }
        }
        // if (recrdData.some((i) => i.fullPath === route.fullPath))
        //   return false
      }
      setRecrdData(JSON.stringify(this.editableTabs));

      // recrdData.forEach((item) => {
      //   if (item.fullPath == to.fullPath) {
      //     flag = false;
      //     this.editableTabsValue = item.name;
      //   }
      // });
      // if (flag) {
      //   let name = Number(this.editableTabs.slice(-1)[0].name);
      //   this.editableTabsValue = JSON.stringify(name + 1);
      //   this.editableTabs.push({
      //     title: this.$route.meta.title,
      //     name: this.editableTabsValue,
      //     content: this.$route.path,
      //   });
      //   setRecrdData(JSON.stringify(this.editableTabs));
      // }
    }
  },
  mounted() {
    // this.tagsBox = document.querySelector('.tags-box')
    // const tagsView = document.querySelector('.tags-view')
    // setTimeout(() => {
    //   this.realWidth = this.tagsBox.clientWidth
    //   this.viewWidth = tagsView.clientWidth
    // }, 1)
    // if (this.viewWidth >= this.realWidth) {
    //   this.leftDisabled = this.rightDisabled = true
    // }
    // window.addEventListener('resize', () => {
    //   this.viewWidth = tagsView.clientWidth //可见宽度/
    // })
  },
  methods: {
    ...mapMutations({
      isactivekey: "IS_ACTIVE_KEY",
      setRouteTags: "SET_ROUTER_TAGS"
      // deleteRouteTags: 'DELETE_ROUTE_TAGS',
    }),

    ...mapActions(["setMenuState", "setRouterTags", "deleteRouterTags"]),

    openMenu(event) {},

    deleteRouteTags(route) {
      const index = findIndex(this.editableTabs, route);
      if (index === -1) return false;
      this.editableTabs.splice(index, 1);
      setRecrdData(JSON.stringify(this.editableTabs));
    },
    onEdit(targetKey, action) {
      let tag = this.editableTabs.filter(vv => {
        if (vv.idNum == targetKey) {
          return vv;
        }
      });
      this[action](tag[0]);
    },
    initRecrd() {
      let recrdData = JSON.parse(getRecrdData()) || [];
      if (recrdData.length > 0) {
        this.editableTabs = recrdData;
        recrdData.forEach(item => {
          if (item.fullPath == this.$route.fullPath) {
            this.isactivekey(this.$route.fullPath);
            this.editableTabsValue = item.idNum;
          }
        });
      } else {
        this.editableTabsValue = "1";
        this.editableTabs.push({
          fullPath: this.$route.fullPath,
          idNum: this.editableTabsValue,
          name: this.$route.name,
          path: this.$route.path,
          title: this.$route.meta.title
        });
        this.isactivekey(this.$route.fullPath);
        setRecrdData(JSON.stringify(this.editableTabs));
      }
    },
    isActiveTag(tag) {
      return tag.fullPath === this.$route.fullPath;
    },
    handleGoRoute(idNum) {
      let flag = true;
      let tag = this.editableTabs.filter(vv => {
        if (vv.idNum == idNum) {
          flag = false;
          return vv;
        }
      });
      const { fullPath, path } = tag[0];
      if (flag) {
        this.$router.push({ path });
      }
      this.editableTabsValue = idNum;

      this.isactivekey(fullPath);
      this.setMenuState("tabs");
      this.$router.push({ path: fullPath });

      // let tag=this.editableTabs.filter((vv)=>{
      //   if(vv.fullPath == targetKey){
      //     return vv
      //   }
      // })
      // const { fullPath, path } = tag[0]
      // if (fullPath === this.$route.fullPath) return false
      // this.$router.push({ path })
      // this.isactivekey(targetKey)
      // this.activeKey=targetKey
    },
    remove(tag) {
      const originTags = [...this.editableTabs];
      if (originTags.length != 1) {
        this.deleteRouteTags(tag);
      }
      if (!this.isActiveTag(tag)) return false; //是activetTag跳转到前一个路由
      const prevTagsIndex = findIndex(originTags, tag);
      if (prevTagsIndex - 1 < 0) {
        //关闭第一个
        if (this.editableTabs.length) {
          //还存在缓存路由
          const route = this.keepLiveTags[0];
          this.$router.replace({ path: route.fullPath });
        } else {
          //不存在
          this.$router.replace({ path: "/dashboard" });
        }
      } else {
        const route = originTags[prevTagsIndex - 1];
        this.deleteRouterTags(route);
        this.isactivekey(route.fullPath);
        this.$router.replace({ path: route.fullPath });
      }
    }

    // handleGoRoute(targetKey) {
    //   let tag=this.keepLiveTags.filter((vv)=>{
    //     if(vv.path == targetKey){
    //       return vv
    //     }
    //   })
    //   const { fullPath, path } = tag[0]
    //   if (fullPath === this.$route.fullPath) return false
    //   this.$router.push({ path })
    //   this.isactivekey(targetKey)
    //   // this.activeKey=targetKey
    // },
    // remove(tag) {
    //   const originTags = [...this.keepLiveTags]
    //   if(originTags.length!==1){
    //     this.deleteRouteTags(tag)
    //   }
    //   if (!this.isActiveTag(tag)) return false //是activetTag跳转到前一个路由
    //   const prevTagsIndex = findIndex(originTags, tag)
    //   if (prevTagsIndex - 1 < 0) {
    //     //关闭第一个
    //     if (this.keepLiveTags.length) {
    //       //还存在缓存路由
    //       const route = this.keepLiveTags[0]
    //       this.$router.replace({ path: route.path })
    //     } else {
    //       //不存在
    //       this.$router.replace({ path: '/dashboard' })
    //     }
    //   } else {
    //     const route = originTags[prevTagsIndex - 1]
    //
    //     this.isactivekey(route.path)
    //     this.$router.replace({ path: route.path })
    //   }
    // },
  }
};
</script>
<style lang="less" scoped>
.router-tags {
  width: 50%;
  // display: flex;
  // align-items: center;
  position: relative;
  padding-left: 16px;
  height: 50px;
  background: #fff;
  //border-top: 1px solid #eee;
  position: absolute;
  left: 60px;
  overflow: hidden;

  // vertical-align: middle;
  .tag-control {
    display: flex;
    position: absolute;
    top: 7px;
    right: 0;
    width: 60px;
    .ant-btn {
      width: 50%;
      height: 27px;
      outline: none;
      border: none;
      box-shadow: none;
      font-size: 12px;
      border-radius: 0;
    }
  }
  .tags-view {
    //width: calc(100% - 60px);
    width: 95%;
    height: 100%;
    overflow: hidden;
    //position: absolute;
  }
  .tags-box {
    display: inline-block;
    height: 100%;
    white-space: nowrap;
    position: absolute;
    top: -10px;
    transition: left 0.2s;
    //overflow: hidden;
    .tag-item {
      height: 100%;
      line-height: 100%;
      background: #ffffff;
      margin: 5px 0px;
      color: #000;
      padding: 5px 12px;
      //border: 1px solid #dadada;
      border-radius: 2px;
      border: none;
      border-left: 1px solid #e4e7ed;
      text-align: center;
      outline: none;
      font-size: 12px;
    }
    .tag-active {
      //background:rgb(63, 158, 255) !important;
      //color:#FFFFFF;
      //background: #FFFFFF;
      color: #09a99f;
    }
    .icon-tag-close {
      visibility: hidden;
      // font-size: 12px;
    }
    .tag-active .icon-tag-close {
      visibility: visible;
      //background: #09a99f;
      //background:rgb(63, 158, 255)
      //background: #f0f0f0;
    }
    :not(.tag-active):hover .icon-tag-close {
      visibility: visible;
      background: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/routerTags.vue